import { ImportLog } from '@sonar-software/sonar-imports';
import React from 'react';

export interface SyncLogsProps {
	logs: ImportLog[];
}

export const SyncLogs: React.FC<SyncLogsProps> = ({ logs }) => {
	if (!logs?.length) {
		return null;
	}

	return (
		<>
			{ logs.map((log) => <pre key={ log.text }>{ log.text }</pre>) }
		</>
	);
};
